const PENDING_QUERY_KEY = 'cb_explorer_pending_query';
const PENDING_SDK_KEY = 'cb_explorer_pending_sdk';

export const PendingQuery = {
  save(query: string, sdk?: string | null) {
    try {
      localStorage.setItem(PENDING_QUERY_KEY, query);
      if (sdk) {
        localStorage.setItem(PENDING_SDK_KEY, sdk);
      } else {
        localStorage.removeItem(PENDING_SDK_KEY);
      }
    } catch {
      // localStorage unavailable (e.g. private browsing, storage full)
    }
  },
  get(): { query: string | null; sdk: string | null } {
    try {
      return {
        query: localStorage.getItem(PENDING_QUERY_KEY),
        sdk: localStorage.getItem(PENDING_SDK_KEY),
      };
    } catch {
      return { query: null, sdk: null };
    }
  },
  clear() {
    try {
      localStorage.removeItem(PENDING_QUERY_KEY);
      localStorage.removeItem(PENDING_SDK_KEY);
    } catch {
      // localStorage unavailable
    }
  },
};
